import {useApolloClient} from '@apollo/client';
import {useCallback} from 'react';

import type {Extension} from 'extensions/content-store/extensionConstants';
import {resolveMcpSetupRedirectInfo} from 'extensions/content-store/extensionInstall';
import MCPSetupRedirectModal from 'extensions/content-store/MCPSetupRedirectModal';
import legacyRunModal from 'ui-library/legacyRunModal';

import {
  navigateToTacMcpServersAndOpenToolsModal,
  refreshCachesAfterMcpDirectoryInstall,
} from './mcpTacSetupRedirectEvents';

/**
 * Hook returning an `onInstall` callback for ContentStoreModal that refreshes caches and
 * shows the MCP setup redirect modal after a directory MCP install.
 */
export function useMcpDirectoryInstallHandler(): (installedExtension: Extension) => Promise<void> {
  const apolloClient = useApolloClient();
  return useCallback(
    async (installedExtension: Extension) => {
      await refreshCachesAfterMcpDirectoryInstall(apolloClient);
      const mcp = resolveMcpSetupRedirectInfo(installedExtension);
      if (mcp == null) {
        return;
      }
      const {serverId, displayName} = mcp;
      legacyRunModal(MCPSetupRedirectModal, {
        extensionId: installedExtension.id,
        displayName,
        onGoToAdminSettings: () =>
          navigateToTacMcpServersAndOpenToolsModal({serverId, serverName: displayName}),
      }).catch(() => undefined);
    },
    [apolloClient]
  );
}
